import React from 'react'
import { AllowedAccess } from 'react-permission-role'
import { useLocation, useParams } from 'react-router-dom'
import { Card, CardContent, Button, Grid } from '@mui/material';

import { useFetchInitAdminLeasesPayments } from './hooks'
import { PaymentsTable } from './PaymentsTable'
import { PaymentsForm } from './PaymentsForm'


const LeasesPayments = (props) => {
    
    const location = useLocation();
    const paramsURL = useParams();
    const useFetchInit = useFetchInitAdminLeasesPayments({location, paramsURL})

    const {
        //------------- Generales
        //------------- globalStates
        globalStates,
        //------------- Helpers
        // Helpers,
        //------------- Formularios
        // Forms,
        //------------- FetchData
        // FetchData,
        //------------- Actions
        Actions
    } = useFetchInit

    // ------------------------------------------------ Generales
    // ------------------------------------------------ globalStates
    const { showForm } = globalStates
    // ------------------------------------------------ Helpers
    // ------------------------------------------------ Formularios
    // ------------------------------------------------ FetchData
    // ------------------------------------------------ Actions
    const { handleClickShowForm } = Actions

    return (
        <AllowedAccess permissions={['132_ARRENDAMIENTOS_PAGOS']} renderAuthFailed={<p>Error</p>}>
            <div className="content">
                {(!showForm) && (
                    <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                            <Card style={{zIndex:'1'}}>
                                <CardContent>
                                    
                                    <div className='h4 mt-1 mb-1'> Pagos pendientes de aprobación</div>
                                    <div className="border-bottom border-dark"></div>
                                    {/* {loadingFetchAllClients && ( <LinearLoading /> )} */}

                                    <div className="d-flex justify-content-end pt-4">
                                        <Button style={{background: "#47c4c7"}} variant="contained" type="button" onClick={() => handleClickShowForm(true)}>
                                            <i className="fa-solid fa-plus"></i> &nbsp; Agregar
                                        </Button>
                                    </div>

                                    <div className="pt-4"></div>
                                    <PaymentsTable useFetchInit={useFetchInit} />
                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>
                )}
                {(showForm) && (
                    <div className="panel-body">
                        <PaymentsForm useFetchInit={useFetchInit} />
                    </div>
                )}
            </div>
        </AllowedAccess>
    )

}

export {
    LeasesPayments
}